<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>广播设备</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备名称：</span>
                <el-input placeholder="请输入项目名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加设备</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="名称">
                    <template slot-scope="scope">
                      <!-- <router-link
                          style="color:#17b2fe"
                          :to="{name:'monitEquipList',params: { id:scope.row.id,type:scope.row.machType }}"
                      >{{ scope.row.name}}</router-link> -->
                      <span>{{ scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.serial }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="验证码">
                    <template slot-scope="scope">
                    <span>{{ scope.row.vcode }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="备注">
                    <template slot-scope="scope">
                    <span>{{ scope.row.remarks }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <!-- <el-button
                        size="mini"
                        style="background:#fff;color:#000;"
                        @click="monitorSyn(scope.row)"
                    >手动同步</el-button> -->
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                  <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="100px"
                    id="formData"
                    :label-position="labelPosition"
                    :rules="rules"
                  >
                    <el-form-item label="名称：" prop="name">
                        <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="序列号：" prop="serial">
                        <el-input v-model="addForm.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="vcode">
                        <el-input v-model="addForm.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="通道号：" prop="channelNo">
                        <el-input v-model="addForm.channelNo" placeholder="请输入通道号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="机器厂家：">
                      <el-select v-model="addForm.machType" clearable placeholder="请选择">
                        <el-option
                          v-for="item in machTypes"
                          :key="item.id"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" v-model="addForm.remarks"></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="dialog-footer" style="margin-top:20px;text-align: center;">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                  </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      dialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      machType: '1', // 添加窗口-tag默认显示页
      addForm: {
        id: '',
        name: '',
        machType: '1',
        channelNo:'',
        serial: '',
        vcode: '',
        remarks: '',
        projectId:''
      }, // 添加设备表单数组
      // addForm1: {}, // 编辑设备表单数组
      radio: 1, // 弹窗口-录像机是否传值
      addFormVisible: false, // 弹出框是否显示
      tableDataName: '', // 搜索数据名
      tableDataEnd: [], // 监控表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      flag: false, // 搜索数据flag值
      groupId: util.session.get('groupId'),
      curMachType: '1', //当前设备  1：海康   2：大华
      dataText: '数据加载中...',
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }]
      },
       rules1: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        serial:[{ required: true, message: '请输入设备序列号', trigger: 'blur' }],
        vcode:[{ required: true, message: '请输入设备验证码', trigger: 'blur' }],
        channelNo:[{ required: true, message: '请输入设备通道号', trigger: 'blur' }],
      },
      //厂家
      machTypes:[
        // {id:'0',label:'瞳声',value:'1'}
      ],
    }
  },
  mounted() {
    this.getTypeDict()
    this.getData()
  },
  methods: {
    // 搜索数据 111
    doFilter() {
      // if (this.tableDataName == '') {
      //   this.$message.warning('查询条件不能为空！')
      //   return
      // }
      // var that = this
      // var option = {
      //   name: this.tableDataName,
      //   pageNum: this.currentPage,
      //   pageSize: this.pageSize,
      //   deviceName: '',
      //   projectId: util.session.get('groupId')
      // }
      // myHttp.getMonitListByProjectId(option).then(function(resp) {
      //   if (resp.data.code == '200') {
      //     var list = resp.data.data.monitorList || [],
      //       arr = []
      //     for (var i = 0; i < list.length; i++) {
      //       if (list[i].name.split(that.tableDataName).length > 1) {
      //         arr.push(list[i])
      //         list[i].index = arr.length
      //       }
      //     }
      //     that.tableDataEnd = arr
      //     if (that.tableDataEnd != '') {
      //       that.$message.success('搜索结果如下')
      //     } else {
      //       that.$message.error('数据不存在')
      //     }
      //     console.log(that.tableDataEnd.index)
      //   } else {
      //     that.$message.error(resp.data.msg)
      //   }
      // })
      this.currentPage = 1
      this.currentChangePage()
      // this.flag = true
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // // 监控当前页码
    currentChangePage() {
      this.getData()
    },

    // 获取数据
    getData() {
      var option = {
        name: this.tableDataName,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.selectBroadcastByProjectIdPage(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
//获取字典类型
getTypeDict(type) {
      var that = this
      myHttp
        .getDictByType({
          type: 'broadcast_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
          
              that.machTypes = resp.data.data.dictList
       
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.curMachType = row.machType
      // this.addForm = row
      this.addForm.id = row.id
      this.addForm.name = row.name
      this.addForm.machType = row.machType
      this.addForm.channelNo = row.channelNo
      this.addForm.serial = row.serial
      this.addForm.vcode = row.vcode
      this.addForm.remarks = row.remarks
      this.addForm.projectId = util.session.get('groupId')
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          myHttp.delBroadcast({
            id: row.id
          }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      // console.log(this.addForm.id);
      this.dialogTitle = '新增设备'
      this.addFormVisible = true
      //海康-萤石云
      this.addForm = {
        id: '',
        name: '',
        machType: '1',
        channelNo:'',
        serial: '',
        vcode: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }
      
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            //添加
            myHttp.createBroadcast(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            delete that.addForm.cameraList
            delete that.addForm.createDate
            if (that.addForm.password == '') {
              delete that.addForm.password
            }
            myHttp.updateBroadcast(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    // sumbitAddRow1(formName) {
    //   var that = this
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       if (that.addForm1.id == '') {
    //         myHttp.monitorCreateInfo(that.addForm1).then(
    //           function(resp) {
    //             if (resp.data.code == '200') {
    //               that.$message.success('添加成功')
    //               that.addFormVisible = false
    //               that.getData()
    //             } else {
    //               that.$message.error(resp.data.msg)
    //             }
    //           },
    //           function() {}
    //         )
    //       } else {
    //         delete that.addForm1.cameraList
    //         delete that.addForm1.createDate
    //         myHttp.monitorUpdateInfo(that.addForm1).then(
    //           function(resp) {
    //             if (resp.data.code == '200') {
    //               that.$message.success('修改成功')
    //               that.addFormVisible = false
    //               that.getData()
    //             } else {
    //               that.$message.error(resp.data.msg)
    //             }
    //           },
    //           function() {}
    //         )
    //       }
    //     }
    //   })
    // },
    //同步
    // monitorSyn(row) {
    //     var that = this
    //     myHttp.registerMonitor({
    //       id: row.id
    //     }).then(function(resp) {
    //       if (resp.data.code == '200') {
    //         that.$message.success('同步摄像头成功')
    //       } else {
    //         that.$message.error(resp.data.msg)
    //       }
    //     })
    // },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 3vh;
    }

    .add-form .el-form-item {
        margin-top: 20px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>